export function reactToLeaf(el) {
    let form = document.getElementById('frm-phorumForm');
    let threadInput = form.querySelector('input[name=thread]');
    let reactionSpan = form.querySelector('span#reaction');
    reactionSpan?.remove(); // remove old reactionSpan
    reactionSpan = document.createElement("span"); //create new one
    reactionSpan.id = 'reaction';
    reactionSpan.classList.add('badge');
    reactionSpan.innerHTML = 'reakce na ' + el.dataset.target + ' (' + el.dataset.date + ')' + '<a href="#" id="cancelReaction" class="text-danger"><i class="fas fa-close fa-fw"></i></a>';

    form.prepend(reactionSpan);
    threadInput.value = el.dataset.id; // sets new thread value

    // new event for new generated cancel link
    document.getElementById('cancelReaction').addEventListener('click', (e)=>{
        threadInput.value = '';
        reactionSpan.remove();
        e.preventDefault();
    });
        
}





